import type { WebModule } from "../../core/modules";
import { GuidesList } from "./routes/list";
import { GuideReaderPage } from "./routes/reader";
import { GuideEditor } from "./routes/editor";
import { GuidePublicPage } from "./routes/public";
import { RecentGuidesCard } from "./components/recent-guides";

// Guides en étapes markdown : liste, lecteur, éditeur (admin) et lecteur
// public hors shell sur /g/:slug.
const guides: WebModule = {
  name: "guides",
  routes: [
    { path: "/guides", element: <GuidesList /> },
    { path: "/guides/:slug", element: <GuideReaderPage /> },
    { path: "/guides/:id/modifier", element: <GuideEditor />, adminOnly: true },
  ],
  publicRoutes: [{ path: "/g/:slug", element: <GuidePublicPage /> }],
  nav: [
    {
      title: "Guides",
      items: [{ to: "/guides", label: "Guides", icon: "book", end: true }],
    },
  ],
  homeWidgets: [{ id: "guides-recent", element: <RecentGuidesCard /> }],
};

export default guides;
